import { render, staticRenderFns } from "./village-form.vue?vue&type=template&id=b884a920&"
import script from "./village-form.vue?vue&type=script&lang=js&"
export * from "./village-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports